var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dash',{attrs:{"icon":"fa fa-calendar","titulo":"ETAPAS VENCENDO ENTRE 14 E 10 DIAS E NÃO MARCADAS COMO NÃO ADITIVAR","qtd":_vm.qtd,"loading":_vm.loading,"color":"#ff4040"}})
}
var staticRenderFns = []

export { render, staticRenderFns }